"use client";

import { useEffect } from "react";

export default function useAutoReloadOnConnectionError(
    maxReloads = 2,
    errorKeyword = "Connection closed"
) {
    useEffect(() => {
        const reloads = parseInt(
            sessionStorage.getItem("reload_count") || "0",
            10
        );

        const handleReload = () => {
            if (reloads < maxReloads) {
                console.warn(`${errorKeyword} detected. Reloading...`);
                sessionStorage.setItem("reload_count", String(reloads + 1));
                setTimeout(() => window.location.reload(), 1000);
            } else {
                console.warn("Max reload attempts reached. No further reload.");
            }
        };

        const onError = (event) => {
            if (event?.message?.includes(errorKeyword)) {
                handleReload();
            }
        };

        const onUnhandledRejection = (event) => {
            const reason = event.reason?.message || event.reason;
            if (reason?.includes?.(errorKeyword)) {
                handleReload();
            }
        };

        window.addEventListener("error", onError);
        window.addEventListener("unhandledrejection", onUnhandledRejection);
        window.addEventListener("load", () => {
            sessionStorage.removeItem("reload_count");
        });

        return () => {
            window.removeEventListener("error", onError);
            window.removeEventListener(
                "unhandledrejection",
                onUnhandledRejection
            );
        };
    }, [maxReloads, errorKeyword]);
}
